import Modal from '@components/shared/Modal'
import { getProfileMeta, getStatusMeta } from '@services/userManagementService'
import { formatDateTime, formatRelativeAccess, getInitials, getPermissionLabel } from './usersUtils'

export default function UserDetailsDrawer({ user, isOpen, onClose, loading = false }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalhes do usuário"
      subtitle="Visão consolidada do acesso, perfil e histórico recente."
      icon="fa-id-card"
      size="large"
      footer={<button type="button" className="btn btn-outline" onClick={onClose}>Fechar</button>}
    >
      {loading || !user ? (
        <div className="users-table-skeleton">
          <div className="users-skeleton-row" />
          <div className="users-skeleton-row" />
          <div className="users-skeleton-row" />
        </div>
      ) : (
        (() => {
          const profileMeta = getProfileMeta(user.profile)
          const statusMeta = getStatusMeta(user.status)

          return (
            <div className="users-details-layout">
              <aside className="users-details-summary">
                <div className="users-avatar users-avatar-lg">{getInitials(user.fullName)}</div>
                <h3>{user.fullName}</h3>
                <p>{user.email}</p>
                <div className="users-details-badges">
                  <span className={`users-badge ${profileMeta?.badgeClass}`}>{profileMeta?.label}</span>
                  <span className={`users-badge ${statusMeta?.badgeClass}`}>{statusMeta?.label}</span>
                </div>
                <dl className="users-kv-list">
                  <div><dt>Cargo</dt><dd>{user.roleTitle || 'Não informado'}</dd></div>
                  <div><dt>Telefone</dt><dd>{user.phone || 'Não informado'}</dd></div>
                  <div>
                    <dt>Último acesso</dt>
                    <dd>{formatRelativeAccess(user.lastAccessAt)}<br />{formatDateTime(user.lastAccessAt)}</dd>
                  </div>
                  <div><dt>Criado em</dt><dd>{formatDateTime(user.createdAt)}</dd></div>
                </dl>
              </aside>

              <div className="users-details-content">
                <section className="users-detail-card">
                  <header>
                    <h4>Permissões associadas ao perfil</h4>
                    <span>{user.permissions.length} permissões</span>
                  </header>
                  <div className="users-permissions-list">
                    {user.permissions.length > 0 ? (
                      user.permissions.map((permission) => (
                        <span key={permission} className="users-permission-pill">{getPermissionLabel(permission)}</span>
                      ))
                    ) : (
                      <span className="users-permission-pill">Nenhuma permissão detalhada retornada pela API.</span>
                    )}
                  </div>
                </section>

                <section className="users-detail-card">
                  <header>
                    <h4>Histórico recente</h4>
                    <span>Últimas interações relevantes</span>
                  </header>
                  <div className="users-history-list">
                    {user.recentActions.length > 0 ? (
                      user.recentActions.map((item) => (
                        <article key={item.id} className="users-history-item">
                          <div className="users-history-dot" />
                          <div>
                            <strong>{item.action}</strong>
                            <p>{item.description}</p>
                            <span>{formatDateTime(item.timestamp)}</span>
                          </div>
                        </article>
                      ))
                    ) : (
                      <article className="users-history-item">
                        <div className="users-history-dot" />
                        <div>
                          <strong>Sem histórico detalhado</strong>
                          <p>O backend não retornou eventos recentes para este usuário.</p>
                        </div>
                      </article>
                    )}
                  </div>
                </section>
              </div>
            </div>
          )
        })()
      )}
    </Modal>
  )
}
